import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';
import { IconChevronRight } from '@tabler/icons-react';
import { refreshToken } from 'aws-auth-lib';
import Breadcrumbs from '../../component/extended/Breadcrumbs';
import { useRole } from '../../utils/RoleContext';
import Header from './Header';
import Sidebar from './Sidebar';
import navigation from 'menu-items';

const Main = styled('main')(({ theme }) => ({
    ...theme.typography.mainContent,
    flex: '1 1 0%',
    minWidth: 0,
    minHeight: '100dvh',
    width: 'auto',
    margin: 0,
    padding: 0,
    borderRadius: 0
}));

function MainLayout() {
    const theme = useTheme();
    const desktop = useMediaQuery(theme.breakpoints.up('md'));
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { role } = useRole();
    const { pathname } = useLocation();
    const hasSidebar = Boolean(role) && role !== 'PATIENT';
    const isAgenda = pathname.replace(/\/$/, '') === '/agenda';

    useEffect(() => {
        setDrawerOpen(false);
    }, [desktop, pathname, role]);

    useEffect(() => {
        let active = true;
        refreshToken()
            .then((token) => {
                if (active) sessionStorage.setItem('token', token.toString());
            })
            .catch(() => {
                // Authentication and API requests already handle session failures.
            });
        return () => {
            active = false;
        };
    }, []);

    return (
        <Box sx={{ display: 'flex', minHeight: '100dvh', minWidth: 0 }}>
            <CssBaseline />
            {hasSidebar && (
                <Sidebar
                    desktop={desktop}
                    drawerOpen={desktop || drawerOpen}
                    drawerToggle={() => setDrawerOpen(false)}
                />
            )}
            <Main
                sx={
                    isAgenda
                        ? {
                              display: 'flex',
                              flexDirection: 'column',
                              '& > .MuiAppBar-root': { flexShrink: 0 }
                          }
                        : undefined
                }
            >
                <AppBar position="sticky" sx={{ bgcolor: '#FDFCFF' }}>
                    <Toolbar
                        sx={{
                            paddingTop: 0,
                            minHeight: '80px !important',
                            gap: { xs: 0.5, sm: 2 }
                        }}
                    >
                        <Header
                            desktop={desktop}
                            hasSidebar={hasSidebar}
                            open={drawerOpen}
                            handleLeftDrawerToggle={() => {
                                if (!desktop && hasSidebar)
                                    setDrawerOpen((open) => !open);
                            }}
                        />
                    </Toolbar>
                </AppBar>
                <Breadcrumbs
                    separator={IconChevronRight}
                    navigation={navigation(role)}
                    icon
                    title
                    rightAlign
                />
                <Outlet />
            </Main>
        </Box>
    );
}
export default MainLayout;
